var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 92,
    viewBox: "0 0 100 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-results",
    transform: "translate(-1.252 -4.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(2.446 5.597)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5171",
    "data-name": "Path 5171",
    d: "M78.207,45.227H35.731L24.21,31.52H66.686Z",
    transform: "translate(9.917 10.965)",
    fill: "#ecb2e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5172",
    "data-name": "Path 5172",
    d: "M2,45.227H25.919L37.439,31.52H13.521Z",
    transform: "translate(-2 10.965)",
    fill: "#e1cce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5173",
    "data-name": "Path 5173",
    d: "M35.731,45.227,24.21,31.52v46.8H66.686V45.227Z",
    transform: "translate(10.405 11.286)",
    fill: "#e1cce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5174",
    "data-name": "Path 5174",
    d: "M21.618,45.227H9.22V78.32H33.139V31.52Z",
    transform: "translate(2.301 11.286)",
    fill: "#ecb2e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5175",
    "data-name": "Path 5175",
    d: "M53.835,31.035,50.66,27.86A22.754,22.754,0,0,1,48.9,29.855,22.753,22.753,0,0,1,46.91,31.61l3.175,3.175a4.94,4.94,0,0,0,1.324,4.6l14.3,14.3a4.953,4.953,0,1,0,7-7l-14.3-14.3a4.819,4.819,0,0,0-4.579-1.34Z",
    transform: "translate(23.438 8.806)",
    fill: "#e1cce0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_149",
    "data-name": "Ellipse 149",
    cx: 22.387,
    cy: 22.387,
    r: 22.387,
    transform: "translate(34.58)",
    fill: "#e1cce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5176",
    "data-name": "Path 5176",
    d: "M44.21,41.165A15.843,15.843,0,0,1,32.9,36.473a16.035,16.035,0,0,1,0-22.642,15.987,15.987,0,0,1,22.626,0,16.035,16.035,0,0,1,0,22.642A15.843,15.843,0,0,1,44.21,41.165Z",
    transform: "translate(12.796 -2.773)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872",
    transform: "translate(1.252 4.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5177",
    "data-name": "Path 5177",
    d: "M56.83,13.432A17.206,17.206,0,0,0,32.5,37.766a17.2,17.2,0,0,0,24.334,0,17.239,17.239,0,0,0,0-24.334ZM55.138,36.074a14.816,14.816,0,1,1,0-20.951A14.714,14.714,0,0,1,55.138,36.074Z",
    transform: "translate(13.544 -2.023)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5178",
    "data-name": "Path 5178",
    d: "M87.535,59.769l-14.3-14.3a6.137,6.137,0,0,0-5.026-1.755L66.2,41.706a23.677,23.677,0,1,0-5.441,5.425l2.011,2.011a6.086,6.086,0,0,0,1.755,5.026l14.3,14.3a6.155,6.155,0,1,0,8.712-8.7Zm-55.481-16.8a21.187,21.187,0,1,1,14.983,6.207A21.036,21.036,0,0,1,32.055,42.967ZM85.844,66.79a3.756,3.756,0,0,1-5.314,0l-14.3-14.3a3.779,3.779,0,0,1-1.005-3.479,1.173,1.173,0,0,0-.319-1.1l-2.266-2.266c.367-.319.734-.622,1.069-.973.351-.351.654-.718.973-1.069l2.266,2.266a1.173,1.173,0,0,0,1.1.319A3.728,3.728,0,0,1,71.547,47.2l14.3,14.3a3.728,3.728,0,0,1,1.1,2.665,3.656,3.656,0,0,1-1.1,2.633Z",
    transform: "translate(10.67 -4.4)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5179",
    "data-name": "Path 5179",
    d: "M27.274,46.449,37.885,33.828,48.5,46.449a1.182,1.182,0,0,0,.91.431H79.9a1.2,1.2,0,0,0,0-2.393H49.964l-9.51-11.313h1.133a1.2,1.2,0,0,0,0-2.393H13.966a1.182,1.182,0,0,0-.91.431L1.536,44.917a1.188,1.188,0,0,0,.91,1.963H26.364A1.3,1.3,0,0,0,27.274,46.449ZM5.015,44.471l9.51-11.313H35.316l-9.51,11.313Z",
    transform: "translate(-1.252 11.721)",
    fill: "#90348a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5180",
    "data-name": "Path 5180",
    d: "M40.7,53.66H28.187a1.2,1.2,0,0,0,0,2.393H40.7a1.2,1.2,0,0,0,0-2.393Z",
    transform: "translate(13.455 25.671)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5181",
    "data-name": "Path 5181",
    d: "M40.7,56.57H28.187a1.2,1.2,0,0,0,0,2.393H40.7a1.2,1.2,0,0,0,0-2.393Z",
    transform: "translate(13.455 27.404)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5182",
    "data-name": "Path 5182",
    d: "M46.1,15.78a1.2,1.2,0,0,0-1.691,0l-3.941,3.941L36.531,15.78a1.2,1.2,0,0,0-1.691,1.691l3.941,3.941L34.84,25.353a1.2,1.2,0,0,0,0,1.691,1.194,1.194,0,0,0,1.691,0L40.472,23.1l3.941,3.941a1.194,1.194,0,0,0,1.691,0,1.2,1.2,0,0,0,0-1.691l-3.941-3.941L46.1,17.471a1.176,1.176,0,0,0,0-1.691Z",
    transform: "translate(17.768 2.333)",
    fill: "#71207c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5183",
    "data-name": "Path 5183",
    d: "M76.062,46.488a1.205,1.205,0,0,0-1.2,1.2v27.11H34.782V36.627a1.2,1.2,0,0,0-2.393,0V74.795H10.863V47.685a1.2,1.2,0,0,0-2.393,0V75.991a1.205,1.205,0,0,0,1.2,1.2H76.062a1.205,1.205,0,0,0,1.2-1.2V47.685A1.205,1.205,0,0,0,76.062,46.488Z",
    transform: "translate(3.047 14.812)",
    fill: "#71207c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResult);
export default __webpack_public_path__ + "static/media/icon_no_result.6d820cd5316b0a3466ef79c85ea2bb90.svg";
export { ForwardRef as ReactComponent };